if (!window.location.pathname.includes("/products")) {
  setTimeout(() => {
    $('[bss-b2b-product-active="true"]').removeAttr("bss-b2b-product-active");
    BSS_B2B.cp.changeProductPrice(
      BSS_B2B.shopData,
      false,
      false
    );
  }, 1000)
}
if (window.location.href.includes("/account/login")) {
  const iconEye =
    '<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16"> <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/> <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/> </svg></span>';
  const iconEyeSlash =
    '<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16"> <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/> <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/> <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/> </svg></span>';
  window.onload = function () {
    const passwordElement = document.querySelector(
      "#customer_login .field:has(input#CustomerPassword)"
    );
    if (
      passwordElement &&
      !document.querySelector(".icon-show-hide-password")
    ) {
      passwordElement.classList.add("password-field");
      const inputPassword = passwordElement.querySelector("input");
      inputPassword.setAttribute("name", "customer[password]");
      const iconShowHidePassword = document.createElement("div");
      iconShowHidePassword.classList.add("icon-show-hide-password");
      passwordElement.appendChild(iconShowHidePassword);
      iconShowHidePassword.innerHTML = iconEye;
      passwordElement.style.position = "relative";
      iconShowHidePassword.style.position = "absolute";
      iconShowHidePassword.style.cursor = "pointer";
      iconShowHidePassword.style.top = "2px";
      iconShowHidePassword.style.right = "0px";
      inputPassword.style.paddingRight = "32px";
      inputPassword.style.fontSize = "16px";
      iconShowHidePassword.addEventListener("click", function () {
        if (inputPassword.type === "password") {
          inputPassword.type = "text";
          iconShowHidePassword.innerHTML = iconEyeSlash;
        } else {
          inputPassword.type = "password";
          iconShowHidePassword.innerHTML = iconEye;
        }
      });
    }
  }; 
}

window.addEventListener("cart_changed", () => {
    let timerId = setInterval(() => {
        BSS_B2B.qi.handleSetupQuantity();
    }, 200);

    setTimeout(() => {
        clearInterval(timerId);
    }, 6000);
});

(() => {
  if(window.location.pathname === '/account/register') {
    const loop = setInterval(() => {
      let phoneField = document.querySelector(".field-phone-field");
      if(phoneField) {
        clearInterval(loop);
        restyleRF();
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 8000)

    function restyleRF(){
      const elements = document.querySelectorAll('.formbuilder-text');
      elements.forEach(function(element) {
          element.classList.add("field");
          const label = element.querySelector("label");
          const input = element.querySelector("input");
      
          if (label && input) {
              input.parentNode.insertBefore(label, input.nextSibling);
              input.setAttribute("placeholder", " ");
          }
      });
    }
  }

  if(window.location.pathname === '/pages/become-a-dealer') {
    const loop = setInterval(() => {
      let phoneField = document.querySelector(".field-phone-field");
      if(phoneField) {
        clearInterval(loop);
        restyleRFB2B();
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 8000)
    
    function restyleRFB2B(){
      $('.form-vertical').addClass("customer")
      $("#RegisterForm").removeAttr("id")
      $('.formbuilder-text.form-group, .formbuilder-select').addClass("field")
      $('.formbuilder-text.form-group, .field').each(function (index) {
          const label = $(this).find("label");
          const input = $(this).find("input");
          if(input && label) {
              input.after(label);
              input.attr('placeholder', " ");
          }
      })
      $('.formbuilder-autocomplete.form-group.field-country-field').addClass("field")
      const countryChildren = $('.formbuilder-autocomplete.form-group.field-country-field').children()
      countryChildren[1].placeholder = ' '
      countryChildren[2].placeholder = ' '
      countryChildren[2].setAttribute('type', 'text')
      countryChildren[3].after(countryChildren[0])
  }
  }
})()


if(BSS_B2B) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      // BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
      // BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
    }, 500);
  });

  setTimeout(() =>{
    const targetMiniCart = document.querySelector("cart-drawer");
    if (targetMiniCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
           BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
      });
      mutationObserver.observe(targetMiniCart, { attributes: true });
    }
  }, 500)

  //fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', '.cart__ctas button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
  
}